import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";

import {
  ref,
  getDownloadURL,
  updateMetadata,
  uploadBytes,
  deleteObject,
  // ...
} from "firebase/storage";

import { auth, storage } from "@/firebaseConfig";

class firebaseService {

  //auth services
  register(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  sendPasswordResetEmail(email) {
    return sendPasswordResetEmail(auth, email);
  }

  logout() {
    return signOut(auth);
  }


  //image services
  retrieveImg(url) {
    const imageRef = ref(storage, url);
    var newMetadata = {
      cacheControl: 'public,max-age=604800',
    };
    updateMetadata(imageRef, newMetadata);
    return getDownloadURL(imageRef);
      
  }

  uploadImg(file){
    if(!file) return Promise.resolve(null);
    const imageRef = ref(storage, file.name);
    return uploadBytes(imageRef, file); 
  }

  deleteImg(url){
    const imageRef = ref(storage, url);
    return deleteObject(imageRef, url);
  }
}

export default new firebaseService();
